export const defaultHedgeSimulationForm = {
  swap: false,
  swapFloor: false,
  cap: false,
  zeroCostCollar: false,
};
